"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.export.csv': 'Esporta CSV',
    'reports.export.excel': 'Esporta Excel',
};
